import { SkeletonLoader } from "../../SkeletonLoader";

/**
 * Mobile page-chrome skeletons, shown only on first entry
 * (`isInitialLoading`). Heights mirror the loaded controls (40px buttons, 40px
 * tab strip) so the sticky-toolbar offsets in `mobile/index.tsx` stay correct
 * while loading and nothing shifts when data arrives.
 */

/** Title + the two-line last-updated description. */
export const MobileHeaderSkeleton = () => (
  <div className="flex flex-col gap-3">
    <SkeletonLoader
      variant="rounded"
      motionReduce
      width="60%"
      height={38}
      radius="lg"
    />
    <div className="flex flex-col gap-1">
      <SkeletonLoader
        variant="rounded"
        motionReduce
        radius="md"
        width="100%"
        height={13}
      />
      <SkeletonLoader
        variant="rounded"
        motionReduce
        radius="md"
        width="70%"
        height={13}
      />
    </div>
  </div>
);

/** Date-range field (fills) + the 40×40 filter button. */
export const MobileToolbarSkeleton = () => (
  <div className="flex items-center gap-2">
    <SkeletonLoader
      variant="rounded"
      motionReduce
      height={40}
      radius="lg"
      className="flex-1"
    />
    <SkeletonLoader
      variant="rounded"
      motionReduce
      width={40}
      height={40}
      radius="lg"
    />
  </div>
);

/** Full-width segmented view-by tabs. */
export const MobileTabsSkeleton = () => (
  <SkeletonLoader variant="rounded" motionReduce height={40} radius="xl" />
);

/** Metric/sort trigger + Export control row. */
export const MobileSortExportSkeleton = () => (
  <div className="flex items-center justify-between gap-2">
    <SkeletonLoader
      variant="rounded"
      motionReduce
      radius="md"
      width={140}
      height={18}
    />
    <SkeletonLoader
      variant="rounded"
      motionReduce
      width={110}
      height={32}
      radius="lg"
    />
  </div>
);
